export default [
    {id: 1, name: 'BMW', price: 110},
    {id: 2, name: 'Google', price: 200},
    {id: 3, name: 'Apple', price: 280},
    {id: 4, name: 'Twitter', price: 83.7},
]